/**
 * Testimonial slider — one slide per block, track translate + dots + arrows.
 * Touch: horizontal swipe. Trackpad: two-finger horizontal scroll (wheel deltaX).
 */
(function () {
  const ROOT = '[data-testimonial-slider]';

  function init(root) {
    var viewport = root.querySelector('[data-testimonial-viewport]');
    var track = root.querySelector('[data-testimonial-track]');
    var slides = root.querySelectorAll('[data-testimonial-slide]');
    var dots = root.querySelectorAll('[data-testimonial-dot]');
    var prev = root.querySelector('[data-testimonial-prev]');
    var next = root.querySelector('[data-testimonial-next]');
    if (!viewport || !track || slides.length === 0) return;

    var n = slides.length;
    var i = 0;

    function go(index) {
      if (n < 1) return;
      i = ((index % n) + n) % n;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      slides.forEach(function (el, j) {
        el.setAttribute('aria-hidden', j !== i ? 'true' : 'false');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        if (j === i) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
      if (prev) {
        prev.disabled = n <= 1;
        prev.setAttribute('aria-disabled', n <= 1 ? 'true' : 'false');
      }
      if (next) {
        next.disabled = n <= 1;
        next.setAttribute('aria-disabled', n <= 1 ? 'true' : 'false');
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(i - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(i + 1);
      });
    }
    dots.forEach(function (dot, j) {
      dot.addEventListener('click', function () {
        go(j);
      });
    });

    /* Thumb / touch swipe (mobile): horizontal swipe changes slide */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        touchActive = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    function handleTouchEnd(clientX, clientY) {
      if (!touchActive) return;
      touchActive = false;
      if (n < 2) return;
      var dx = clientX - touchStartX;
      var dy = clientY - touchStartY;
      var minSwipe = 48;
      if (Math.abs(dx) < minSwipe) return;
      if (Math.abs(dy) >= Math.abs(dx)) return;
      if (dx < 0) {
        go(i + 1);
      } else {
        go(i - 1);
      }
    }

    viewport.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches.length) return;
        handleTouchEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      function () {
        touchActive = false;
      },
      { passive: true }
    );

    /* Laptop trackpad: two-finger horizontal scroll → prev/next (wheel deltaX) */
    var wheelLockUntil = 0;
    var wheelCooldownMs = 420;

    viewport.addEventListener(
      'wheel',
      function (e) {
        if (n < 2) return;
        if (e.ctrlKey) return;
        var scale = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 800 : 1;
        var dx = e.deltaX * scale;
        var dy = e.deltaY * scale;
        if (Math.abs(dx) < Math.abs(dy)) return;
        if (Math.abs(dx) < 12) return;
        var now = Date.now();
        if (now < wheelLockUntil) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        wheelLockUntil = now + wheelCooldownMs;
        if (dx < 0) {
          go(i + 1);
        } else {
          go(i - 1);
        }
      },
      { passive: false }
    );

    go(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(ROOT)) {
      boot(e.target);
    }
  });
})();
